// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/settings/v1/system_management.proto" (package "c1.api.settings.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.settings.v1.SystemManagementConfig
 */
export interface SystemManagementConfig {
    /**
     * Global settings (shutoff semantics - false means enabled, true means disabled)
     *
     * @generated from protobuf field: bool notifications_shutoff = 1;
     */
    notificationsShutoff: boolean;
    /**
     * @generated from protobuf field: bool bundle_automations_shutoff = 2;
     */
    bundleAutomationsShutoff: boolean;
    /**
     * @generated from protobuf field: bool workflow_automations_shutoff = 3;
     */
    workflowAutomationsShutoff: boolean;
    /**
     * Metadata
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6;
     */
    updatedAt?: Timestamp;
}
/**
 * Quota overrides response - wraps the TenantQuota data
 *
 * @generated from protobuf message c1.api.settings.v1.SystemManagementQuotaOverrides
 */
export interface SystemManagementQuotaOverrides {
    /**
     * Map of quota reference enum values to custom values
     *
     * @generated from protobuf field: map<int32, int64> quota_overrides = 1;
     */
    quotaOverrides: {
        [key: number]: number;
    };
}
/**
 * @generated from protobuf message c1.api.settings.v1.GetSystemManagementConfigRequest
 */
export interface GetSystemManagementConfigRequest {
}
/**
 * @generated from protobuf message c1.api.settings.v1.GetSystemManagementConfigResponse
 */
export interface GetSystemManagementConfigResponse {
    /**
     * @generated from protobuf field: c1.api.settings.v1.SystemManagementConfig config = 1;
     */
    config?: SystemManagementConfig;
}
/**
 * @generated from protobuf message c1.api.settings.v1.UpdateSystemManagementConfigRequest
 */
export interface UpdateSystemManagementConfigRequest {
    /**
     * @generated from protobuf field: c1.api.settings.v1.SystemManagementConfig config = 1;
     */
    config?: SystemManagementConfig;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.settings.v1.UpdateSystemManagementConfigResponse
 */
export interface UpdateSystemManagementConfigResponse {
    /**
     * @generated from protobuf field: c1.api.settings.v1.SystemManagementConfig config = 1;
     */
    config?: SystemManagementConfig;
}
/**
 * Quota override methods
 *
 * @generated from protobuf message c1.api.settings.v1.GetSystemManagementQuotaOverridesRequest
 */
export interface GetSystemManagementQuotaOverridesRequest {
}
/**
 * @generated from protobuf message c1.api.settings.v1.GetSystemManagementQuotaOverridesResponse
 */
export interface GetSystemManagementQuotaOverridesResponse {
    /**
     * @generated from protobuf field: c1.api.settings.v1.SystemManagementQuotaOverrides quota_overrides = 1;
     */
    quotaOverrides?: SystemManagementQuotaOverrides;
}
// @generated message type with reflection information, may provide speed optimized methods
class SystemManagementConfig$Type extends MessageType<SystemManagementConfig> {
    constructor() {
        super("c1.api.settings.v1.SystemManagementConfig", [
            { no: 1, name: "notifications_shutoff", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "bundle_automations_shutoff", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "workflow_automations_shutoff", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.SystemManagementConfig
 */
export const SystemManagementConfig = new SystemManagementConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SystemManagementQuotaOverrides$Type extends MessageType<SystemManagementQuotaOverrides> {
    constructor() {
        super("c1.api.settings.v1.SystemManagementQuotaOverrides", [
            { no: 1, name: "quota_overrides", kind: "map", K: 5 /*ScalarType.INT32*/, V: { kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.SystemManagementQuotaOverrides
 */
export const SystemManagementQuotaOverrides = new SystemManagementQuotaOverrides$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSystemManagementConfigRequest$Type extends MessageType<GetSystemManagementConfigRequest> {
    constructor() {
        super("c1.api.settings.v1.GetSystemManagementConfigRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.GetSystemManagementConfigRequest
 */
export const GetSystemManagementConfigRequest = new GetSystemManagementConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSystemManagementConfigResponse$Type extends MessageType<GetSystemManagementConfigResponse> {
    constructor() {
        super("c1.api.settings.v1.GetSystemManagementConfigResponse", [
            { no: 1, name: "config", kind: "message", T: () => SystemManagementConfig }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.GetSystemManagementConfigResponse
 */
export const GetSystemManagementConfigResponse = new GetSystemManagementConfigResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSystemManagementConfigRequest$Type extends MessageType<UpdateSystemManagementConfigRequest> {
    constructor() {
        super("c1.api.settings.v1.UpdateSystemManagementConfigRequest", [
            { no: 1, name: "config", kind: "message", T: () => SystemManagementConfig },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.UpdateSystemManagementConfigRequest
 */
export const UpdateSystemManagementConfigRequest = new UpdateSystemManagementConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSystemManagementConfigResponse$Type extends MessageType<UpdateSystemManagementConfigResponse> {
    constructor() {
        super("c1.api.settings.v1.UpdateSystemManagementConfigResponse", [
            { no: 1, name: "config", kind: "message", T: () => SystemManagementConfig }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.UpdateSystemManagementConfigResponse
 */
export const UpdateSystemManagementConfigResponse = new UpdateSystemManagementConfigResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSystemManagementQuotaOverridesRequest$Type extends MessageType<GetSystemManagementQuotaOverridesRequest> {
    constructor() {
        super("c1.api.settings.v1.GetSystemManagementQuotaOverridesRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.GetSystemManagementQuotaOverridesRequest
 */
export const GetSystemManagementQuotaOverridesRequest = new GetSystemManagementQuotaOverridesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSystemManagementQuotaOverridesResponse$Type extends MessageType<GetSystemManagementQuotaOverridesResponse> {
    constructor() {
        super("c1.api.settings.v1.GetSystemManagementQuotaOverridesResponse", [
            { no: 1, name: "quota_overrides", kind: "message", T: () => SystemManagementQuotaOverrides }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.GetSystemManagementQuotaOverridesResponse
 */
export const GetSystemManagementQuotaOverridesResponse = new GetSystemManagementQuotaOverridesResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.settings.v1.SystemManagementService
 */
export const SystemManagementService = new ServiceType("c1.api.settings.v1.SystemManagementService", [
    { name: "GetSystemManagementConfig", options: { "authz.method": { role: "VIEWER" } }, I: GetSystemManagementConfigRequest, O: GetSystemManagementConfigResponse },
    { name: "UpdateSystemManagementConfig", options: { "authz.method": { role: "EDITOR" } }, I: UpdateSystemManagementConfigRequest, O: UpdateSystemManagementConfigResponse },
    { name: "GetSystemManagementQuotaOverrides", options: { "authz.method": { role: "VIEWER" } }, I: GetSystemManagementQuotaOverridesRequest, O: GetSystemManagementQuotaOverridesResponse }
]);
